import React, { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import humanDrive from "../../assets/human-drive.svg";
import logoLogin from "../../assets/logo-login.svg";
import "./Login.css";

export function Login() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/numeros", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (submitting) return;

    setError(null);
    setSubmitting(true);

    try {
      await login(email, password, remember);
      navigate("/numeros");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Não foi possível entrar.");
      setSubmitting(false);
    }
  };

  return (
    <div className="login">
      <div className="login__card">
        <div className="login__media">
          <img
            src={humanDrive}
            alt="De Carona com Toro"
            className="login__media-img"
          />
        </div>

        <div className="login__panel">
          <img
            src={logoLogin}
            alt="Rafael Toro Academia de Finanças"
            className="login__logo"
          />

          <h1 className="login__title">Faça login</h1>

          <form className="login__form" onSubmit={handleSubmit} noValidate>
            <label className="login__field">
              <span className="login__label">E-mail</span>
              <input
                type="email"
                className="login__input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </label>

            <label className="login__field">
              <span className="login__label">Senha</span>
              <input
                type="password"
                className="login__input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </label>

            <label className="login__remember">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              <span>Lembrar login</span>
            </label>

            {error && <p className="login__error">{error}</p>}

            <button
              type="submit"
              className="btn btn--yellow login__submit"
              disabled={submitting}
            >
              {submitting ? (
                <span className="login__submit-spinner" aria-hidden="true" />
              ) : (
                "Acessar"
              )}
            </button>
          </form>

          <p className="login__helper">
            O acesso é feito com o mesmo e-mail
            <br />e a mesma senha da Área do Aluno.
          </p>
        </div>
      </div>
    </div>
  );
}
